import { render, staticRenderFns } from "./SchemeDetailPlugin.vue?vue&type=template&id=2ce3dd2e&scoped=true"
import script from "./SchemeDetailPlugin.vue?vue&type=script&lang=js"
export * from "./SchemeDetailPlugin.vue?vue&type=script&lang=js"
import style0 from "./SchemeDetailPlugin.vue?vue&type=style&index=0&id=2ce3dd2e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce3dd2e",
  null
  
)

export default component.exports